<template>
  <transition
    name="fade-content"
    appear
    mode="out-in"
  >
    <div class="landing-page-inner landing-page-inner_about">
      <div class="landing-page__container landing-page__container_expand">
        <div class="about-content">
          <div class="about__left">
            <div class="about__left-section">
              <div class="about__left-text">
                <span class="about__left-text_bold">
                  UPPERBUSINESS
                </span>
                - {{ $t('landingPage.aboutPage.text') }}
              </div>
              <div class="about__left-text">
                <span class="about__left-text_bold">
                  UPPERBUSINESS
                </span>
                - {{ $t('landingPage.aboutPage.staffInfo') }}
              </div>
              <div class="about__left-text">
                <span class="about__left-text_bold">
                  UPPERBUSINESS
                </span>
                - {{ $t('landingPage.aboutPage.partners') }}
              </div>
              <div class="about__left-text">
                {{ $t('landingPage.aboutPage.info') }}
                <a
                  class="about__left-link"
                  rel="noopener noreferrer"
                  aria-label="Upper Business"
                  @click="openNewWindow()"
                >
                  uppercase.group
                </a>
              </div>
            </div>
          </div>
          <div class="about__right">
            <div class="about__image">
              <transition
                name="fade-el"
                mode="out-in"
                appear
              >
                <v-lazy-image
                  :src="require('@/assets/images/landing/about-img.jpg')"
                  :srcPlaceholder="require('@/assets/images/landing/phImage.svg')"
                  alt="logo"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'About',
  methods: {
    openNewWindow() {
      const link = 'https://uppercase.group/';
      window.open(link);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../sass/mixins";

  .about {

    &-content {
      display: flex;
      padding-top: 160px;
      align-items: center;

      @include mobile {
        flex-wrap: wrap;
        padding-top: 128px;
        padding-bottom: 130px;
      }
    }

    &__left {
      width: 37%;
      margin-right: 100px;

      @include tablet-landscape {
        margin-right: 15px;
        width: 100%;
      }

      &-section {
        max-width: 700px;
        width: 100%;
      }

      &-link {
        cursor: pointer;
      }

      &-text {
        font: $font-size-landing-md $font-landing-global;
        color: $color-white;
        line-height: 1.4;

        a {
          color: $color-white;
          transition: opacity .15s ease-in;
          text-decoration: none;
          position: relative;

          &:after {
            content: '';
            bottom: -2px;
            left: 0;
            position: absolute;
            height: 1px;
            background: $color-white;
            width: 100%;
            transition: opacity .15s ease-in;
          }

          &:hover {
            opacity: .8;

            &:after {
              opacity: .8;
            }
          }
        }

        @include mobile {
          font-size: $font-size-landing-sm;
        }

        &_bold {
          font-family: $font-landing-heavy;
        }
      }
      &-text + &-text {
        margin-top: 20px;
      }

    }

    &__image {
      max-width: 851px;
      max-height: 578px;
      overflow: hidden;
    }

    &__right {
      margin-left: 40px;

      @include tablet-landscape {
        margin-left: 15px;
      }

      @include mobile {
        display: none;
      }
    }
  }

@include mobile {
  .about__left-section {
    padding-top: 50px;
  }
}

</style>
